import { Suspense, useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "./i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { useAuth } from "./utils/useAuth";
import { useStartup } from "./utils/useStartup";
import { getStartupMessage } from "./transports/startup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/main.scss";
import { toCamelCase } from "./utils/objectHelper";
import { ProjectManagerPopUpContainer } from "./containers";
import LeadLinkerAndLinkerPopUpContainer from "./containers/LeadLinkerAndLinkerPopUp/LeadLinkerAndLinkerPopUp";

export function App() {
    const { setStartupMessage } = useStartup();
    const { auth, logout, setCurrentUser } = useAuth();
    const didRequest = useRef(false);
    const [showSplashScreen, setShowSplashScreen] = useState(true);

    useEffect(() => {
        const requestUser = async () => {
            try {
                if (!didRequest.current) {
                    const startupMessage = await getStartupMessage();
                    if (startupMessage) {
                        setCurrentUser(toCamelCase(startupMessage.user));
                    }

                    setStartupMessage(startupMessage);
                }
            } catch (error) {
                if (!didRequest.current) {
                    logout();
                }
            } finally {
                setShowSplashScreen(false);
            }

            return () => (didRequest.current = true);
        };

        if (auth) {
            // noinspection JSIgnoredPromiseFromCall
            requestUser();
            return;
        }

        logout();
        setShowSplashScreen(false);
    }, [auth]);

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <I18nProvider>
                <LayoutProvider>
                    <ToastContainer
                        autoClose={3000}
                        position="bottom-right"
                        hideProgressBar={true}
                        theme="colored"
                    />
                    <ProjectManagerPopUpContainer />
                    <LeadLinkerAndLinkerPopUpContainer />
                    {showSplashScreen ? (
                        <LayoutSplashScreen />
                    ) : (
                        <>
                            <Outlet />
                            <MasterInit />
                        </>
                    )}
                </LayoutProvider>
            </I18nProvider>
        </Suspense>
    );
}
